import { BreadcrumbItem } from '@components/display/breadcrumbs';
import { APP_PREFIX_PATH, BASE_URL } from '@constants/common';
import { capitalizeWords } from '@utils/common';
import { IntlShape, MessageDescriptor } from 'react-intl';
import { Link, LinkProps } from 'react-router-dom';

const baseURL = new URL(BASE_URL);
const pathToVP = (urlSuffix: string = '', parameters: { name: string; value: string }[] = []) => {
    const url = new URL(urlSuffix, baseURL);
    if (parameters) {
        parameters.forEach((parameter) => url.searchParams.append(parameter.name, parameter.value));
    }
    return url;
};

const toNext = (route: string) => `${APP_PREFIX_PATH}${route}`;

const toLogin = (withNext = true) =>
    `${APP_PREFIX_PATH}/auth/login${
        withNext ? `?next=${encodeURIComponent(window.location.pathname + window.location.search)}` : ''
    }`;

const RedirectToVP = () => {
    window.location.replace(pathToVP('/').toString());
    return null;
};

const PrefixedLink = ({ to, ...props }: LinkProps) => {
    const prefixedTo = typeof to === 'string' && !to.startsWith(APP_PREFIX_PATH) ? APP_PREFIX_PATH + to : to;

    return <Link to={prefixedTo} {...props} />;
};

const rootSegmentMessages: Record<string, MessageDescriptor> = {
    firmware: { id: 'navbar.firmware', defaultMessage: 'Firmware' },
    firmwares: { id: 'navbar.firmware', defaultMessage: 'Firmware' },
    'media-assets': { id: 'navbar.mediaAssets', defaultMessage: 'Media assets' },
    repairs: { id: 'navbar.repairDocs', defaultMessage: 'Repair docs' },
    'online-training': { id: 'navbar.onlineTraining', defaultMessage: 'Online Training' },
    events: { id: 'navbar.events', defaultMessage: 'Events' },
    news: { id: 'navbar.news', defaultMessage: 'News' },
    blog: { id: 'navbar.blog', defaultMessage: 'Blog' },
    videos: { id: 'navbar.videos', defaultMessage: 'Videos' },
    'software-integrators-program': {
        id: 'navbar.softwareIntegratorsProgram',
        defaultMessage: 'Software Integrators Program',
    },
    developers: { id: 'navbar.developers', defaultMessage: 'Developers' },
    'rla-form': { id: 'navbar.rlaForm', defaultMessage: 'RLA Form' },
};

export const getBreadcrumbsFromPath = (pathname: string, intl: IntlShape): BreadcrumbItem[] => {
    const segments = pathname.split('/').filter(Boolean);

    if (segments[0] === APP_PREFIX_PATH.slice(1)) {
        segments.shift();
    }

    if (segments.length === 0) {
        return [
            {
                label: intl.formatMessage({ id: 'navbar.overview', defaultMessage: 'Overview' }),
                to: APP_PREFIX_PATH,
            },
        ];
    }

    return segments.map((segment, index) => {
        const decodedSegment = decodeURIComponent(segment);
        const rootSegmentMessage = index === 0 ? rootSegmentMessages[decodedSegment] : undefined;

        return {
            label: rootSegmentMessage
                ? intl.formatMessage(rootSegmentMessage)
                : capitalizeWords(decodedSegment.replace(/-/g, ' ')),
            to: `${APP_PREFIX_PATH}/${segments.slice(0, index + 1).join('/')}`,
        };
    });
};

export { pathToVP, PrefixedLink, RedirectToVP, toLogin, toNext };
